var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZone3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1149.118 2061",
    style: {
      enableBackground: "new 0 0 1149.118 2061"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#E961B1",
      strokeWidth: 46.6102,
      strokeMiterlimit: 10
    },
    x1: 0,
    y1: 1079.341,
    x2: 1149.118,
    y2: 1079.341
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#E961B1",
      strokeWidth: 46.6102,
      strokeMiterlimit: 10
    },
    d: "M0,1618.199h611.965 c51.779,0,93.754-41.974,93.754-93.75v-443.572V710.644c0-40.917-33.171-74.086-74.089-74.086H0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#E961B1",
      strokeWidth: 46.6102,
      strokeMiterlimit: 10
    },
    d: "M440.9,1618.199v59.178 c0,60.827,49.312,110.137,110.141,110.137h598.077"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.468,
    y: -0.594,
    style: {
      fill: "none"
    },
    width: 1147.411,
    height: 2061
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000133519614887598021580000012829585916573345956_"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZone3);
export default __webpack_public_path__ + "static/media/zone_3.f6a321c5.svg";
export { ForwardRef as ReactComponent };